export * from './usuario-agro-historial.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/usuarios/usuario-agro-historial/index.ts